
import {Prop, Vue, Component} from 'vue-property-decorator';
import loginApi from "@/apis/login/login";
import {checkVerify,sendEmailCode} from "@/apis/myInfo/myInfo";
import {getMobilexdomain} from '@/utils/utils';
import i18n from '@/lang';
import { Dialog, Toast } from 'vant';

const isMobilePhone = (param: string):boolean => {
  return /1\d{10}/.test(param);
}

const isEmail = (param: string):boolean => {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(param);
}

@Component
export default class FindPassword extends Vue{
  private stepMap = {
    0: 'getCode',
    1: 'verifyCode',
    2: 'resetPassword',
  }
  private stepNow: number = 0;
  private accountType: 'phone' | 'email' = 'phone';

  // step0
  private account: string = '';
  private picCodeInput: string = ''
  private picCodeUrl: string = '';
  private sessionid = ''
  // step1
  private codeFromServer: string = '';
  // step2
  private password: string = '';
  private passwordRepeat: string = '';
  private sign: string = '';
  private expires: string = '';
  private uid:string = ''
  private key:string = '';

  public bigTitle:string = "";
  public forgetInfoData:any = null;
  public showMobileEmailSelected:boolean = false;//显示是否下拉手机号码和邮箱
  public mobileEmailSelectedLists:any = [];
  public needBindEmailOrMobile:boolean = false;//需要用户绑定邮箱或者手机号码
  public accountPlaceholder:string = i18n.t('Account.请输入您的邮箱/手机号') as string;
  public selectIndex = 0;//

  created() {
    let tempTitle = this.$route.query.bigTitle as string;
    if(tempTitle != "" && tempTitle != null && tempTitle != undefined){
      this.bigTitle = tempTitle;
    }else{
      this.bigTitle = i18n.t('Account.找回密码') as string;
    }
    this.$setNavInfo({title: this.bigTitle});
    let tmpJsonData = this.$route.query.jsondata as string;
    if(tmpJsonData != "" && tmpJsonData != null && tmpJsonData != undefined){
      this.forgetInfoData = JSON.parse(tmpJsonData);
      if((this.forgetInfoData.mobile != null && this.forgetInfoData.mobile != "") 
        || (this.forgetInfoData.email != null && this.forgetInfoData.email != "")){
        this.showMobileEmailSelected = true;
      }else{
        this.needBindEmailOrMobile = true;//需要提示用户去绑定
        this.accountPlaceholder = i18n.t('Account.请输入要绑定邮箱手机号') as string;
      }
      if(this.forgetInfoData.mobile != null){
        this.mobileEmailSelectedLists.push(this.forgetInfoData.mobile);
      }
      if(this.forgetInfoData.email != null){
        this.mobileEmailSelectedLists.push(this.forgetInfoData.email);
      }
      if(this.mobileEmailSelectedLists.length>0){
        this.selectIndex = 0;
        this.account = this.mobileEmailSelectedLists[0]['key'];
      }
    }
    this.getPicCode();
  }

  /**
   * 选择重置方式
   */
  selectResetMethod(item:any,pindex:number){
    this.account = item.key;
    this.selectIndex = pindex;
  }

  getVerifyCode() {
    let sendType = 'forgetpassword';
    if(this.needBindEmailOrMobile){
      sendType = 'bindmobile';
    }
    if (isMobilePhone(this.account) || this.account.indexOf("mobile")>-1) {
      this.accountType = "phone";
      let mobilexdomain = getMobilexdomain();
      let postData = {
        verify: this.picCodeInput,
        sessionid: this.sessionid,
        mobile: this.account, // email or phone
        type: sendType,
        mobilexdomain:mobilexdomain,
      };
      checkVerify(postData,false).then((resData:any) => {
        this.account = resData.account;
        this.stepNow = 1
        this.$setNavInfo({
          title: `${this.accountType === 'email' ? i18n.t('ktpMy.邮箱') : i18n.t('Account.短信')}${i18n.t('Account.验证')}`,
          backConfig: () => {
            this.stepNow -- ;
            this.$setNavInfo({
              title: i18n.t('Account.找回密码') as string
            })
          }
        })
        this.$forceUpdate();
      }).catch((e:any)=>{
        if(e.status == 0){
          Dialog.alert({
            title:'系统提示',
            message: e.message
          }).then(() => {});
        }
      })
      return;
    }
    if (isEmail(this.account) || this.account.indexOf("email")>-1) {
      this.accountType = "email";
      let postData = {
        verify:this.picCodeInput, 
        email:this.account, 
        sessionid:this.sessionid, 
        type:sendType
      };
      sendEmailCode(postData,false).then((resData:any) => {
        this.account = resData.account;
        this.stepNow = 1
        this.$setNavInfo({
          title: `${this.accountType === 'email' ? i18n.t('ktpMy.邮箱') : i18n.t('Account.短信')}${i18n.t('Account.验证')}`,
          backConfig: () => {
            this.stepNow -- ;
            this.$setNavInfo({
              title: i18n.t('Account.找回密码') as string
            })
          }
        })
        this.$forceUpdate();
      }).catch((e:any)=>{
        if(e.status == 0){
          Dialog.alert({
            title:'系统提示',
            message: e.message
          }).then(() => {});
        }
      })
      return;
    }
    return;
  }

  getPicCode() {
    loginApi.getFigureCode().then(res => {
      this.sessionid = res.sessionid
      this.picCodeUrl = res.url
    }).catch(e => {
      console.log(e);
    })
  }


  verifyCode() {
    let xAuth = null;
    if(this.forgetInfoData != null){
      xAuth = this.forgetInfoData['xAuth'];
    }
    switch (this.accountType) {
      case "email":
        loginApi.forgetPasswordByEmail({
          code: this.codeFromServer,
          email: this.account,
          xAuth: xAuth,
        }).then((res) => {
          this.sign = res.sign;
          this.expires = res.expires;
          this.uid = res.uid;
          if(res.key != null){
            this.key = res.key;
          }
          this.$forceUpdate()
          this.stepNow = 2;
          this.$setNavInfo({
            title: i18n.t('Account.重置密码') as string,
            backConfig: () => {
              this.stepNow --;
              this.$setNavInfo({
                title: `${this.accountType === 'email' ? i18n.t('ktpMy.邮箱') : i18n.t('Account.短信')}${i18n.t('Account.验证')}`,
                backConfig: () => {
                  this.stepNow -- ;
                  this.$setNavInfo({
                    title: i18n.t('Account.找回密码') as string
                  })
                }
              })
            }
          })
        })
        break;
      case "phone":
        loginApi.forgetPasswordByMobile({
          code: this.codeFromServer,
          mobile: this.account,
          xAuth: xAuth,
        }).then((res) => {
          this.sign = res.sign;
          this.expires = res.expires;
          this.uid = res.uid;
          if(res.key != null){
            this.key = res.key;
          }
          this.stepNow = 2;
          this.$setNavInfo({
            title: i18n.t('Account.重置密码') as string,
            backConfig: () => {
              this.stepNow --;
              this.$setNavInfo({
                title: `${this.accountType === 'email' ? i18n.t('ktpMy.邮箱') : i18n.t('Account.短信')}${i18n.t('Account.验证')}`,
                backConfig: () => {
                  this.stepNow -- ;
                  this.$setNavInfo({
                    title: i18n.t('Account.找回密码') as string
                  })
                }
              })
            }
          })
          this.$forceUpdate();
        })
        break;
      default:
        this.$dialog.alert({
          title: '错误',
          message: '账号类型错误',
        })
        return;
    }
  }

  resetCode() {
    if (this.password !== this.passwordRepeat) {
      this.$dialog.alert({
        title: i18n.t('Common.错误') as string,
        message:  i18n.t('Account.两次输入的密码不一致，请您检查密码') as string
      }).then(() => {
      })
      return;
    }
    loginApi.resetPassword({
      uid: this.uid,
      expires: this.expires,
      sign: this.sign,
      password: this.password,
      key: this.key,
    }).then(() => {
      this.$dialog.alert({
        title: i18n.t('Common.修改成功') as string,
        message: i18n.t('Account.密码修改成功请前去登陆') as string,
      }).then(() => {
        this.$router.push('/login')
        this.stepNow = 0;
      })
    })
  }
  
}
